module.exports = __webpack_public_path__ + "img/gifting-online-dark.d802ccd8.svg";